import type { ReactNode } from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

export interface FormSectionProps {
  /** Section heading, e.g. "Identity" or "Model & Provider". */
  title: string;
  /** Optional helper text rendered under the heading. */
  description?: string;
  children: ReactNode;
  className?: string;
}

/**
 * Groups related fields inside a create/edit page (see `EntityFormPage`) into a
 * labeled, breathing-room-having card, instead of a bare `<div>`. Stack multiple
 * `FormSection`s top-to-bottom rather than putting them behind tabs - see the
 * README in this directory for the reasoning. For a two-column field layout
 * within one section, wrap the relevant fields in your own
 * `grid grid-cols-1 md:grid-cols-2 gap-4` - that doesn't need a dedicated
 * primitive.
 */
export function FormSection({
  title,
  description,
  children,
  className,
}: FormSectionProps) {
  return (
    <Card className={className}>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        {description && <CardDescription>{description}</CardDescription>}
      </CardHeader>
      <CardContent className="space-y-4">{children}</CardContent>
    </Card>
  );
}
